import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ProductService from '../../Services/ProductService';

export const getExperience = createAsyncThunk(
    'Experience/getExperience',
    async (data) => {

        const varibles = {
            productId: data
        }

        const res = await ProductService.createGetData(varibles);
        return res.data;
    })



export const ExperienceSlice = createSlice({
    name: 'Experience',
    initialState: {
        loading: true,
        data: [],
        menu: [],
        categories: [],
        lastStep: 0,
        review: [],
        features: [],
        featureCategories: [],
        activityTypes: [],
        specTemplate: [],
        productType: "",
        policy: [],
        criteria: [],
        guestInfo: [],
        taxAndFee: [],
        covid: [],
        currencyList:[],
        customStrategyTitle:[],
        title: "",
        commissions:[],
        rooms:[]

    },
    reducers: {
        stepReducer: (state, action) => {


            state.menu = action.payload
        },
        titleReducer: (state, action) => {
            state.title = action.payload
        },
        // Wizard kapanınca: bir sonraki açılışta bayat veriyle Steps'in mount
        // olup getOldData'yı 2 kez çağırmasını önler (loading=true -> Skeleton).
        resetExperience: (state) => {
            state.loading = true
            state.menu = []
        },

    },

    extraReducers: (builder) => {


        builder.addCase(getExperience.pending, (state, { payload }) => {
            state.loading = true
        })

        builder.addCase(getExperience.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.data = payload.data;
            state.menu = payload.menu;
            state.categories = payload.categories;
            state.lastStep = payload.lastStep;
            state.review = payload.review;
            state.features = payload.features;
            state.featureCategories = payload.featureCategories || [];
            state.activityTypes = payload.activityTypes || [];
            state.specTemplate = payload.specTemplate || [];
            state.productType = payload.productType
            state.policy = payload.policy
            state.criteria = payload.criteria
            state.guestInfo = payload.guestInfo
            state.taxAndFee = payload.taxAndFee
            state.covid = payload.covid
            state.currencyList = payload.currencyList
            state.customStrategyTitle=payload.customStrategyTitle
            state.commissions = payload.commissions
            state.rooms = payload.rooms


        })


        builder.addCase(getExperience.rejected, (state, { payload }) => {
            state.loading = false
        })

    }
})


export const { stepReducer, titleReducer, resetExperience } = ExperienceSlice.actions;

export const ExperienceReducer = ExperienceSlice.reducer